import { Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
import { Radio, Spin, Table, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const ImagePreAddress = Url.baseURL[0] + Url.implantImage;
const ImplantIndex = (props) => {
  const ColumnsAnalyses = [
    {
      title: "img",
      dataIndex: "img",
      key: "img",
      render: (object, item) => {
        return (
          <img style={{ width: 100 }} src={ImagePreAddress + item?.imageUrl} />
        );
      },
    },
    {
      title: "Answer",
      dataIndex: "img",
      key: "img",
      render: (object, item) => {
        return _returnAnswerColumn(item);
      },
    },
  ];
  const [loadingItemId, setLoadingItemId] = useState(0);
  useEffect(() => {
    _getList();
  }, []);

  const _returnAnswerColumn = (item) => {
    let findElement = props.coreData[Url.getListImplant]?.[
      Url.action
    ]?.data?.answer?.find((o) => o.implantImageId == item.id);

    const _onChangeAnswer = async (id) => {
      console.log(id, item);
      let _toserver = {
        ImplantImageId: item.id,
        UserGusesIpmantTypeId: id,
      };
      setLoadingItemId(item.id);

      let url = Url.implantsaveanswer;
      let res = await props.actions.CallCoreServicesActionWithToken(
        url,
        _toserver
      );
      console.log(res);
      if (res.hasError) {
        message.error(res.message);
        return;
      }

      let lastAnswer = {
        ...props.coreData[Url.getListImplant]?.[Url.action]?.data,
      };

      if (findElement == null) {
        lastAnswer?.answer.push({
          implantImageId: item.id,
          userGusesIpmantTypeId: id,
        });
        await props.actions.OfflineCoreServices(
          Url.getListImplant,
          Url.action,
          lastAnswer,
          false
        );
      }

      let index = lastAnswer?.answer.findIndex(
        (o) => o.implantImageId == item.id
      );
      lastAnswer.answer[index] = {
        implantImageId: item.id,
        userGusesIpmantTypeId: id,
      };
      await props.actions.OfflineCoreServices(
        Url.getListImplant,
        Url.action,
        lastAnswer,
        false
      );

      message.success(res.message);
    };
    return (
      <div>
        {props.coreData[Url.implantsaveanswer]?.[Url.action]?.isFetching &&
        loadingItemId == item.id ? (
          <Spin
            style={{ marginLeft: 5, marginRight: 5 }}
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 24,
                  color: "blue",
                }}
                spin
              />
            }
          />
        ) : (
          <Radio.Group
            value={findElement?.userGusesIpmantTypeId}
            onChange={(e) => _onChangeAnswer(e.target.value)}
          >
            <div>
              <Radio value={0}>neodent</Radio>
            </div>
            <div>
              <Radio value={1}>staruman_bl</Radio>
            </div>
            <div>
              <Radio value={2}>staruman_sp</Radio>
            </div>

            <div>
              <Radio value={3}>staruman_blt</Radio>
            </div>

            <div>
              <Radio value={4}>biohorizon</Radio>
            </div>
            <div>
              <Radio value={5}>italia</Radio>
            </div>
          </Radio.Group>
        )}
      </div>
    );
  };

  const _getList = async () => {
    let url = Url.getListImplant;
    let res = await props.actions.CallCoreServicesActionWithToken(url, {});
    console.log(res);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
  };

  return (
    <div>
      <Table
        columns={ColumnsAnalyses}
        dataSource={
          props.coreData[Url.getListImplant]?.[Url.action]?.data?.image
        }
        loading={props.coreData[Url.getListImplant]?.[Url.action]?.isFetching}
      />
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ImplantIndex);
